import profile from '@/assets/images/home/landing-profile.jpg'
import { useTestimonials } from '../api/getTestimonial'
import { useState } from 'react'

export const testimonials = [
  {
    name: 'Royal Crizhmah Ghale',
    position: 'Grand Daughter of Queen Elizabeth Ghale',
    message: `“We needed a workspace that inspired creativity and productivity, and RR Interiors delivered beyond our expectations. Their design is modern, functional, and reflects our company's brand perfectly. Our employees love the new space, and we've noticed a boost in morale and efficiency. We highly recommend their services.”`,
    image: profile,
  },
  {
    name: 'Royal Crizhmah Ghale',
    position: 'Grand Daughter of Queen Elizabeth Ghale',
    message: `“We needed a workspace that inspired creativity and productivity, and RR Interiors delivered beyond our expectations. Their design is modern, functional, and reflects our company's brand perfectly. Our employees love the new space, and we've noticed a boost in morale and efficiency. We highly recommend their services.”`,
    image: profile,
  },
  {
    name: 'Royal Crizhmah Ghale',
    position: 'Grand Daughter of Queen Elizabeth Ghale',
    message: `“We needed a workspace that inspired creativity and productivity, and RR Interiors delivered beyond our expectations. Their design is modern, functional, and reflects our company's brand perfectly. Our employees love the new space, and we've noticed a boost in morale and efficiency. We highly recommend their services.”`,
    image: profile,
  },

  {
    name: 'Royal Crizhmah Ghale',
    position: 'Grand Daughter of Queen Elizabeth Ghale',
    message: `“We needed a workspace that inspired creativity and productivity, and RR Interiors delivered beyond our expectations. Their design is modern, functional, and reflects our company's brand perfectly. Our employees love the new space, and we've noticed a boost in morale and efficiency. We highly recommend their services.”`,
    image: profile,
  },
]
export const Tree = () => {
  const [currentPage, setCurrentPage] = useState(1)
  const testimonials = useTestimonials()
  if (testimonials.isLoading) {
    return (
      <div className="flex h-96 w-full items-center justify-center">
        <div className="size-[1em] animate-loader  rounded-[50%] text-[45px] text-[#D4AF37]"></div>
      </div>
    )
  }

  if (!testimonials.data) {
    return null
  }

  // counting the total number of pages
  const totalPages = Math.ceil((testimonials.data?.length as number) / 4 || 1)

  // making the pageNumbers element
  const pageNumbers: JSX.Element[] = []
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(
      <div
        onClick={() => setCurrentPage(i)}
        className={`${i === currentPage ? 'bg-[#D4AF37] ' : 'bg-[#F5F5F5] '} cursor-pointer px-[12px] py-[5px] md:px-[17px] md:py-[7.5px] lg:px-[22px] lg:py-[10px]`}
      >
        <span
          key={i}
          className={`${i === currentPage ? 'text-[#F5F5F5] [font-weight:700] ' : 'text-[#333333] [font-weight:400]'} font-nunito text-[12px] leading-[19.2px] md:text-[14px] md:leading-[22.4px] lg:text-[16px] lg:leading-[25.6px]   `}
        >
          {i}
        </span>
      </div>
    )
  }

  // Get the testimonials for the current page
  const startIndex = (currentPage - 1) * 4
  const endIndex = startIndex + 4
  const currentTestimonials = testimonials.data?.slice(startIndex, endIndex)

  return (
    <div className="flex flex-col gap-y-[24px] md:gap-y-[37.5px] lg:gap-y-[50px]">
      <div className="relative flex flex-col flex-wrap lg:flex-row ">
        <div className="absolute h-full  border-[1.5px] border-[#D4AF37] md:left-0 lg:left-1/2 lg:-translate-x-1/2"></div>
        {currentTestimonials.map((testimonial, index) => (
          <Leaf
            key={`${index}+${testimonial.name}`}
            {...testimonial}
            index={index}
          />
        ))}
      </div>
      <div className="flex justify-center gap-x-[2px]">{pageNumbers}</div>
    </div>
  )
}

type LeafProps = {
  index: number
  name: string
  role: string
  profilePhoto: { id: string; url: string }
  review: string
}
const Leaf = ({
  profilePhoto: { url },
  index,
  review,
  name,
  role,
}: LeafProps) => {
  return (
    <div
      className={`${index % 2 === 0 ? '  lg:flex-row' : 'lg:mt-0 '} mt-20 flex w-full flex-row-reverse items-center gap-x-[40px] lg:w-1/2  `}
    >
      <div className="relative flex w-full flex-col items-center justify-center gap-y-[12px] border-[3px] border-[#D4AF37] bg-[#F5F5F5] px-[29px] py-[41px]">
        <svg
          className={`${index % 2 === 0 ? 'lg:left-[unset] lg:right-0 lg:translate-x-[36.6px] lg:rotate-90' : ' '} absolute left-0 top-1/2 size-[40px]  -translate-y-1/2 translate-x-[-36.6px] -rotate-90`}
          viewBox="-10 -10 120 120"
        >
          <polyline
            points="0 100,50 0,100 100"
            className=" fill-[#F5F5F5] stroke-[#D4AF37] stroke-[6px]"
          />
        </svg>
        <p className="text-center font-nunito text-[12px] font-normal leading-[19.2px] text-[#333333] lg:text-[16px] lg:leading-[25.6px]">
          {review}
        </p>
        <div className="flex flex-col items-center justify-center gap-y-px font-nunito text-[#333333]">
          <h2 className="text-[12px] font-bold leading-[19.2px] lg:text-[16px] lg:leading-[25.6px] ">
            {name}
          </h2>
          <span className=" text-center text-[8px] font-normal leading-[12.8px] lg:text-[12px] lg:leading-[19.2px]">
            {role}
          </span>
        </div>
      </div>
      <div
        className={`${index % 2 === 0 ? 'lg:flex-row ' : ' '} flex shrink-0 flex-row-reverse items-center`}
      >
        <img
          src={url}
          className="size-[40px]  rounded-[50%] border-[3px] border-[#D4AF37] object-cover md:size-[60px]  lg:size-[80px]"
        />
        <div className="w-[32px] border-[1.5px] border-[#D4AF37]"></div>
      </div>
    </div>
  )
}
